import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

// baseURL dinamico: usa o mesmo host de onde o frontend foi servido, na porta 8081.
// Producao -> https://kanban.soluciona.inf.br:8081/ ; Dev -> http://localhost:8081/.
axios.defaults.baseURL = `${window.location.protocol}//${window.location.hostname}:8081/`

axios.interceptors.request.use(
    (config) => {
      const user = localStorage.getItem('userPioneira');
      if (user) {
        const token = JSON.parse(user).token;
        config.headers.Authorization = token;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

createApp(App).use(router).mount('#app')
